import styled, { css } from 'styled-components';

export const StyledButton = styled.button`
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  border-radius: 100px;
  height: 2.3em;
  padding: 0 1.6em;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: center;

  &:disabled {
    cursor: not-allowed;
    /*opacity: 0.5;*/
    background-color: #cecece;
    color: #fff;
  }

  ${({ isBold }) =>
    isBold &&
    css`
      font-weight: bold;
    `}

  /* Variante Primary */
  ${({ variant, backgroundColor, foregroundColor }) =>
    variant === 'primary' &&
    css`
      background-color: ${backgroundColor};
      color: ${foregroundColor ?? '#ffffff'};
      border: 2px solid transparent;

      &:hover:not(:disabled) {
        background-color: ${backgroundColor};
      }
    `}

  /* Variante Secondary */
  ${({ variant, backgroundColor }) =>
    variant === 'secondary' &&
    css`
      background-color: transparent;
      color: ${backgroundColor ?? '#fff'};
      border: 2px solid ${backgroundColor};

      &:hover:not(:disabled) {
        background-color: rgba(0, 0, 255, 0.05);
        border-color: ${backgroundColor};
      }

      &:active:not(:disabled) {
        background-color: rgba(0, 0, 255, 0.1);
        border-color: ${backgroundColor};
      }
    `}

  /* Variante Tertiary */
  ${({ variant, backgroundColor }) =>
    variant === 'tertiary' &&
    css`
      background-color: transparent;
      color: ${backgroundColor};
      border: 2px solid transparent;
      text-decoration: underline;
      padding: 12px 16px;

      &:hover:not(:disabled) {
        background-color: rgba(0, 0, 255, 0.05);
      }

      &:active:not(:disabled) {
        background-color: rgba(0, 0, 255, 0.1);
      }
    `}
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
`;
